




























































































import { PricingBreakdown } from '@/types';
import { formatPrice } from '@/util';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { getPricingBreakdown } from '../services/service';
import { EventType } from '@/constants';

export default Vue.extend({
  name: 'PricingBreakdownModal',
  data () {
    return {
      EventType
    }
  },
  computed: {
    ...mapGetters([
      'jobDetails'
    ]),
    pricingBreakdown (): PricingBreakdown {
      return getPricingBreakdown(this.jobDetails);
    }
  },
  mounted () {
    document.body.classList.add('overflow-hidden');
  },
  methods: {
    formatPrice (value: string): string {
      return formatPrice(value);
    }
  },
  destroyed () {
    document.body.classList.remove('overflow-hidden');
  }
});
